import React from 'react';
import { Box, Typography, Button, CircularProgress, Dialog, DialogTitle, DialogContent } from '@mui/material';

import useBatchPrint from './useBatchPrint';
import { Step1, Step2 } from './steps';
import RenderIf from '../../renderIf';

const BatchPrint = ({ selected, open, closeCallback }) => {
    const {
        isDoingAjax,
        isInitialized,
        headers,
        step,
        inError,
        downloadRef,
        downloadHref,
        reset,
        initializeBatchPrint,
        printInvoices,
        nextStep,
        handleFileName,
    } = useBatchPrint();

    React.useEffect(() => {
        if (open) initializeBatchPrint(closeCallback);
        else reset?.();
    }, [open]);

    const handleClose = async () => {
        closeCallback?.();
    };

    return (
        <Dialog open={open}>
            <DialogTitle>Batch print invoices</DialogTitle>
            <DialogContent>
                <Box>
                    <Box
                        component="a"
                        href={downloadHref}
                        ref={downloadRef}
                        hidden
                    />
                    <RenderIf isTrue={!isInitialized}>
                        <Typography
                            sx={(theme) => {
                                return {
                                    mb: theme.spacing(15),
                                };
                            }}
                        >
                            <CircularProgress size="2rem" /> Initializing batch print...
                        </Typography>
                    </RenderIf>

                    <RenderIf isTrue={isInitialized && step === 1}>
                        <Step1
                            selected={selected}
                            headers={headers}
                        />
                    </RenderIf>

                    <RenderIf isTrue={isInitialized && step === 2}>
                        <Step2
                            handleFileName={handleFileName}
                            isDoingAjax={isDoingAjax}
                            inError={inError}
                        />
                    </RenderIf>
                </Box>
                <Box>
                    <Button
                        onClick={() => handleClose()}
                        color="secondary"
                        variant="contained"
                        disabled={isDoingAjax}
                    >
                        Cancel
                    </Button>

                    <RenderIf isTrue={step === 1}>
                        <Button
                            onClick={() => nextStep()}
                            variant="contained"
                            disabled={isDoingAjax}
                        >
                            Continue to Step 2
                        </Button>
                    </RenderIf>

                    <RenderIf isTrue={step === 2}>
                        <Button
                            onClick={() => printInvoices(selected, closeCallback)}
                            variant="contained"
                            disabled={isDoingAjax}
                        >
                            Generate invoices
                        </Button>
                    </RenderIf>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default BatchPrint;
